import { render, staticRenderFns } from "./specialTask.vue?vue&type=template&id=01c88df6&"
import script from "./specialTask.vue?vue&type=script&lang=js&"
export * from "./specialTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports